<template>
  <b-container class="h-100">
    <b-row class="justify-content-center text-center">
      <b-col align-self="center" cols="12">
        <b-img
          ref="img__success-payment"
          :src="require('@/assets/icon-payment/icon-payment-success.png')"
          width="241"
        ></b-img>
        <h1 ref="text__success-topic" class="text__success-topic">Thank you!</h1>
        <h3 ref="text__success-description" class="text__success-description">
          Your payment was successful
        </h3>
      </b-col>
      <b-col class="d-flex flex-column align-items-center">
        <OrderDetailSummary
          v-if="order"
          ref="component_order-detail-summary"
          class="detail-container mb-3"
          :order="order"
          :payment="payment"
          :hide="{ id: true }"
        />
        <hr class="w-100" style="max-width: 511px" />
        <div v-if="order" class="d-flex flex-column align-items-center my-3">
          <template v-if="hasQuotaLearningUnit">
            <b-button
              ref="button__back-to-submission"
              class="button__back-to-submission"
              variant="success"
              @click="backToSubmission"
              >Back to your submission</b-button
            >
          </template>
          <template v-else>
            <b-button
              ref="button__go-to-your-dashboard"
              class="button__go-to-your-dashboard mb-1"
              variant="success"
              @click="gotoDashboard"
              >Go to your dashboard</b-button
            >
            <b-button ref="button__go-to-homepage" variant="link" @click="gotoHomePage">
              Back to Homepage
            </b-button>
          </template>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import OrderDetailSummary from '@/components/Payment/OrderDetailSummary.vue';
import Order from '@/models/Order';

export default {
  components: { OrderDetailSummary },

  computed: {
    orderId() {
      return parseInt(this.$route.params.orderId);
    },
    evidenceSubmissionId() {
      return (
        this.$route.params.evidenceSubmissionId || this.$route.query.evidenceSubmissionId || null
      );
    },
    order() {
      return Order.query()
        .with(['order_items.learning_unit_option.learning_unit', 'payments'])
        .where('id', this.orderId)
        .first();
    },
    payment() {
      return this.order.payments?.find((payment) => payment.status === 'SUCCESS');
    },
    hasQuotaLearningUnit() {
      // Show "Back to submission" only for VERIFY mode when NOT upgrading
      // If isUpgrade=true, user is upgrading from VERIFY to LEARN_VERIFY, show dashboard
      const isUpgrade = this.$route.query.isUpgrade === 'true';

      if (isUpgrade) return false; // Upgrading plan -> show dashboard

      // Fallback: check if order has VERIFY mode quota
      if (!this.order || !this.order.order_items) return false;
      return this.order.order_items.some(
        (item) => item.learning_unit_option && item.learning_unit_option.option_type === 'QUOTA'
      );
    },
    learningUnitId() {
      if (!this.order || !this.order.order_items) return null;
      const quotaItem = this.order.order_items.find(
        (item) => item.learning_unit_option && item.learning_unit_option.option_type === 'QUOTA'
      );
      return quotaItem?.learning_unit_option?.learning_unit?.id || null;
    }
  },
  async mounted() {
    if (!this.order) {
      await Order.api().fetchOrder(this.orderId);
    }
  },
  methods: {
    gotoDashboard() {
      this.$router.push({
        name: 'user-dashboard'
      });
    },
    gotoHomePage() {
      this.$router.push('/');
    },
    async backToSubmission() {
      // If previousPath exists in query, navigate to it directly
      if (this.$route.query.previousPath) {
        this.$router.push(this.$route.query.previousPath);
        return;
      }

      // Fallback: construct the route if we have the necessary IDs
      if (!this.learningUnitId) return;

      if (this.evidenceSubmissionId) {
        this.$router.push({
          name: 'learning-unit/submission-denied',
          params: {
            learningUnitId: this.learningUnitId,
            evidenceSubmissionId: this.evidenceSubmissionId
          }
        });
        return;
      }
    }
  }
};
</script>

<style lang="css" scoped>
.text__success-topic {
  color: #2dac7e;
  font-weight: 700;
  margin: 40px 0;
}
.text__success-description {
  font-weight: 700;
  margin-bottom: 40px;
}
.detail-container {
  padding: 1.5rem;
  max-width: 511px;
  border-radius: 0.65rem;
  box-shadow: 0px 4px 8.8px 0px rgba(166, 166, 185, 0.55);
}
</style>
